import React from 'react';
import './Tours.css';

const Tours = () => {
  return (
    <div className="tours">
      <div className="tours-container">
        <h1>Our Tours</h1>
        <p>Explore our exciting tour packages</p>
      </div>
    </div>
  );
};

export default Tours;
